<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <el-button size="mini" style="margin-top: 5px" @click="search()">
        查询
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="importDialog()">
        导入
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="excel()">
        导出
      </el-button>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产">
          <el-input
            size="mini"
            v-model="form.houseName"
            placeholder="输入房产搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="年份">
          <el-date-picker v-model="form.year" type="year" value-format="yyyy" placeholder="选择年份" />
        </el-descriptions-item>
        <el-descriptions-item label="月份">
          <el-select v-model="form.month" placeholder="请选择" clearable>
            <el-option
              v-for="item in months"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="600px"
        :data="listData"
        border
        style="margin-top: 8px"
        v-loading="loading"
      >
        <el-table-column prop="name" label="项目" />
        <el-table-column prop="year" label="年份" />
        <el-table-column prop="month" label="月份" />
        <el-table-column prop="amount" label="期初" />
        <el-table-column prop="deduction_amount" label="手工剔除金额" />
        <el-table-column prop="create_at" label="创建时间" />
        <el-table-column prop="admin_name" label="操作员" />
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="sizes,prev, pager, next"
        :page-size.sync="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="导入文件"
      :visible.sync="dialogImportModel"
      width="60%"
      :before-close="handleImportClose"
      v-loading="loading"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary" class="texts">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls或xlsx文件，且不超过7M
        </div>
      </el-upload>
      <el-button size="mini" @click="importExcelData"> 导入 </el-button>
    </el-dialog>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "OpeningAmount",
  components: {
    ErpTree,
  },
  data() {
    return {
      pid: "",
      houseId: "",
      houseName: "",
      form: {
        houseName: "",
        year: "",
        pageSize: 10,
        page: 1,
      },
      dialogImportModel: false,
      totalCount: 0,
      loading: false,
      listData: [],
      url: "",
      fileList: [],
      importForm: {
        route: "",
      },
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
    };
  },
  mounted() {
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/OpeningAmount/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  watch: {
    pid(n) {
      this.search();
    },
    "form.page"(n) {
      this.search();
    },
    "form.pageSize"(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      if (data.type == "project") {
        this.pid = data.id;
      }
      if (data.type == "room") {
        this.houseId = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      this.houseName = tree_str;
    },
    importDialog() {
      this.dialogImportModel = true;
    },
    handleImportClose() {
      this.dialogImportModel = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      this.importForm.route = file.response[0];
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    importExcelData() {
      if (this.importForm.route == "") {
        this.$Message.error("文件不能为空!");
        return false;
      }
      this.$myhttp
        .post("admin/OpeningAmount/importData", this.importForm, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    search() {
      this.loading = true;
      this.form.pid = this.pid;
      this.$myhttp
        .post("admin/OpeningAmount/index", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          this.loading = false;
          // 异步执行成功后
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    excel() {
      this.$myhttp
        .post("admin/OpeningAmount/export", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    }
  },
};
</script>

<style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 265px);
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Forms/openingAmount.vue